<div class="header-layout-wrapper sticky-top">
    <header class="app-header d-flex align-items-center justify-content-between px-4">

        <!-- LEFT: Brand Section -->
        @if (layout.isMobile()) {
        <button type="button" class="hamburger-btn" aria-label="Open menu" (click)="layout.toggleDrawer()">
            <mat-icon>menu</mat-icon>
        </button>
        }
        <div class="brand-section d-flex align-items-center gap-3" routerLink="/dashboard-view">
            <div class="logo-wrapper">
                <img src="public/kudo.png" alt="Logo" class="brand-logo">
            </div>
            <div class="brand-text d-flex flex-column">
                <h1 class="brand-title mb-0">STRADIA</h1>
                <span class="brand-subtitle">MANAGEMENT SYSTEM</span>
            </div>
        </div>

        <!-- RIGHT: Actions & Profile -->
        <div class="actions-section d-flex align-items-center gap-3">

            @if(liveScoreMenu) {
            <a class="live-score-badge d-flex align-items-center gap-2" href="/dashboard" target="_blank">
                <span class="pulse-dot"></span>
                <span class="d-none d-md-inline">Live Score</span>
            </a>
            <div class="v-divider d-none d-md-block"></div>
            }

            <!-- Profile Interactive Card -->
            <div class="profile-card d-flex align-items-center gap-2" (click)="toggleProfileMenu()"
                [class.active]="showProfileMenu">
                <div class="profile-info d-none d-lg-flex flex-column align-items-start text-start">
                    <span class="user-name">{{ globalService.getItem('name') || 'User' }}</span>
                    @if(UserRole) {
                    <span class="user-role">{{ UserRole }}</span>
                    }
                </div>
                <div class="avatar-wrapper">
                    <img src="public/default-profile.png" alt="Avatar" class="profile-avatar">
                    <mat-icon class="profile-chevron" [class.rotated]="showProfileMenu">expand_more</mat-icon>
                </div>

                <!-- Modern Dropdown Menu -->
                @if(showProfileMenu) {
                <div class="profile-dropdown shadow-lg">
                    <div class="dropdown-arrow-tip"></div>

                    <div class="dropdown-header">
                        <span class="dropdown-label text-muted">Account & Security</span>
                    </div>

                    <button class="dropdown-link" (click)="openProfile(); $event.stopPropagation()">
                        <div class="link-icon bg-soft-primary">
                            <mat-icon>manage_accounts</mat-icon>
                        </div>
                        <div class="link-text">
                            <span class="link-title">Account Settings</span>
                            <span class="link-subtitle">Update your profile info</span>
                        </div>
                    </button>

                    <div class="dropdown-divider"></div>

                    <button class="dropdown-link logout-link" (click)="logout(); $event.stopPropagation()">
                        <div class="link-icon bg-soft-danger">
                            <mat-icon>power_settings_new</mat-icon>
                        </div>
                        <div class="link-text">
                            <span class="link-title">Logout</span>
                            <span class="link-subtitle">Sign out of your session</span>
                        </div>
                    </button>
                </div>
                }
            </div>
        </div>

    </header>
</div>


<!-- LOGOUT CONFIRMATION DIALOG -->
<ng-template #confirmLogoutDialog>
    <div class="p-3 text-center">
        <div class="mb-2 mt-2">
            <i class="material-icons text-danger" style="font-size: 48px;">logout</i>
        </div>
        <h4 class="fw-bold mb-3 text-danger">Confirm Logout</h4>
        <p class="text-dark mb-4 fw-bold">Are you sure you want to logout from the Management System?</p>

        <div class="d-flex gap-2 justify-content-center mb-2">
            <button class="btn btn-light rounded-3 px-4 py-2 border fw-semibold shadow-sm" (click)="closeDialog()">
                Cancel
            </button>
            <button class="btn btn-logout-confirm rounded-3 px-5 py-2 fw-semibold shadow-sm" (click)="confirmLogout()">
                Logout
            </button>
        </div>
    </div>
</ng-template>